import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import PlaneAlphaRenderPipeline from "../../../lib/services/render/pipelines/plane_alpha_renderpipeline";

export default class GroundPatch extends SceneObject 
{
 
   render_pipeline:PlaneAlphaRenderPipeline;

  constructor(key: string,texture_name:string,width:number,height:number) 
  {
       super(key)
      
      this.render_pipeline = new PlaneAlphaRenderPipeline(
             key,
            "unlit_texture_alpha",
            texture_name, 
            width, height
          );
  }

  async build(device: GPUDevice,format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
       await this.render_pipeline.build(device, format, shader_service, resource_service);
      
  }    
  
  tick(delta_time: number): void 
  {
     
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
        this.render_pipeline.prepare(device, camera, this.transform);
     
  }
  
  draw(pass: GPURenderPassEncoder): void 
  {
     this.render_pipeline.draw(pass);
  }
   
}